import AddContactModal from '../../components/add-contact-modal'
import supportedCsvDatapoints from '../../util/supported-csv-datapoints'

class AccountEmailReports {

  constructor (Account) {

    this.Account = Account;
    this.container = Account.page.querySelector('.account-email-reports');

    this.selectedEmailReportContacts = [];
    this.selectedEmailReportSensors = [];
    this.existingReports = null;

    this.render();

    this.selectedEmailReportContacts = [];

    this.emailReportContactCount = $(this.container).find('.account-email-reports__contact-count')[0];
    this.emailReportContactsSelect = $(this.container).find('[data-for="account-email-reports-contacts"]')[0];
    this.emailReportContacts = $(this.container).find('.account-email-reports__contacts')[0];

    this.emailReportSensorsSelect = $(this.container).find('[data-for="account-email-reports-sensors"]')[0];
    this.emailReportSensors = $(this.container).find('.account-email-reports__sensors')[0];

    this.bindActions();

    window.PubSub.subscribe("account.loaded", () => {

      window.apiRequest('get', '/user/email-reports').then(r => {

        if(r.type === 'success') {

          console.log(r.data);

          this.selectedEmailReportSensors = r.data.sensors;
          this.selectedEmailReportContacts = r.data.contacts;
          this.existingReports = r.data.reports;

          this.updateEmailReportSensors();
          this.updateEmailReportContacts();
          this.updateEmailReportDownloads();

        }

      });

    });

  }

  bindActions() {

    $(this.emailReportContactsSelect).on('change', e => {

      e.preventDefault();
      const value = this.emailReportContactsSelect.value;

      if(value !== '') {

        if(!this.selectedEmailReportContacts.includes(value)) {

          this.selectedEmailReportContacts.push(value);

          this.updateEmailReportContacts();
          $(this.emailReportContactsSelect).trigger('change');

        }

      }

    });

    $(this.emailReportSensorsSelect).on('change', e => {

      e.preventDefault();
      const value = this.emailReportSensorsSelect.value;

      if(value !== '') {

        if(!this.selectedEmailReportSensors.includes(value)) {

          this.selectedEmailReportSensors.push(value);

          this.updateEmailReportSensors();
          $(this.emailReportSensorsSelect).trigger('change');

        }

      }

    });

    $(this.container).on('click', '.add-contact-button', () => {

      this.addContactForm = new AddContactModal({
        onSuccess: r => {

          const contact = r.data;

          this.selectedEmailReportContacts.push(contact.id);
          this.Account.contacts.push(contact);

          this.updateEmailReportContacts();
          $(this.emailReportContactsSelect).trigger('change');

        },
      });

      this.addContactForm.init();

    });

    $(this.emailReportContacts).on('click', '.account-email-reports__contact__remove__button', e => {

      const contactId = e.currentTarget.dataset.for;

      console.log(contactId);

      this.selectedEmailReportContacts.forEach((contact, i) => {
        if(contact === contactId) {
          delete this.selectedEmailReportContacts[i];
        }
      });

      this.updateEmailReportContacts();
      $(this.emailReportContactsSelect).trigger('change');

    });

    $(this.emailReportSensors).on('click', '.account-email-reports__sensor__remove__button', e => {

      const sensorId = e.currentTarget.dataset.for;

      this.selectedEmailReportSensors.forEach((sensor, i) => {
        if(sensor === sensorId) {
          delete this.selectedEmailReportSensors[i];
        }
      });

      this.updateEmailReportSensors();
      $(this.emailReportSensorsSelect).trigger('change');

    });

  }

  updateEmailReportDownloads() {
    if(this.existingReports && !window.site.isApp) {
      [
        'daily',
        'weekly',
        'monthly',
      ].forEach(key => {

        if(this.existingReports[key].length > 0) {

          const container = this.container.querySelector(`.account-reports-download-list[data-for="${key}_reports"]`);
          let html = '<h4>Recent Reports</h4>';

          this.existingReports[key].forEach(report => {
            html += `
            <div class="account-reports-download-list-item">
              <a href="${report.download}">
                ${report.file}
              </a>
            </div>
            `;
          });

          container.innerHTML = html;

        }

      });

    }
  }

  updateEmailReportSensors() {

    let selectHtml = '';
    let selectedHtml = '';
    let count = 0;

    this.Account.sensors.forEach(sensor => {
      if(!this.selectedEmailReportSensors.includes(sensor.id)) {
        selectHtml += `
        <option value="${sensor.id}">${sensor.sensor_name}</option>
        `;
      } else {

        count++;

        selectedHtml += `
        <div class="account-email-reports__sensor">
        
          <input type="hidden" name="sensors[]" value="${sensor.id}" />
          
          <div class="account-email-reports__sensor__remove">
            <button type="button" class="account-email-reports__sensor__remove__button" data-for="${sensor.id}">
              <i class="far fa-times" title="Remove sensor from report" aria-hidden="true"></i>
              <span class="sr-only">Remove sensor from reports</span>
            </button>
          </div>
          <div class="account-email-reports__sensor__name">
            ${sensor.sensor_name}
          </div>
        </div>
        `;
      }
    });

    if(count === this.Account.sensors.length) {
      selectHtml = '<option value="">-- All Sensors Selected --</option>';
    } else if(this.Account.contacts.length > 0) {
      selectHtml = '<option value="">-- Select Sensor --</option>' + selectHtml;
    } else {
      selectHtml = '<option value="">-- No Sensors Found --</option>';
    }

    this.emailReportSensorsSelect.innerHTML = selectHtml;
    this.emailReportSensors.innerHTML = selectedHtml;

  }

  updateEmailReportContacts() {

    let selectHtml = '';
    let selectedHtml = '';
    let count = 0;

    this.Account.contacts.forEach(contact => {
      if(!this.selectedEmailReportContacts.includes(contact.id)) {
        selectHtml += `
        <option value="${contact.id}">${contact.contact_name}</option>
        `;
      } else {

        count++;
        console.log(contact);

        selectedHtml += `
        <div class="account-email-reports__contact">
        
          <input type="hidden" name="contacts[]" value="${contact.id}" />
          
          <div class="account-email-reports__contact__remove">
            <button type="button" class="account-email-reports__contact__remove__button" data-for="${contact.id}">
              <i class="far fa-times" title="Remove contact from alert" aria-hidden="true"></i>
              <span class="sr-only">Remove contact from reports</span>
            </button>
          </div>
          <div class="account-email-reports__contact__name">
            ${contact.contact_name}
            ${contact.legacy == 1 ? `<div class="inline-label inline-label--warning">This contact needs to be <a href="${window.site.home}/contacts/edit?id=${contact.id}">updated</a> to receive reports</div>` : `
            ${(contact.legacy == 0 && contact.email_consent == 0) ? '<div class="inline-label inline-label--warning">Not receiving emails</div>' : ''}
            `}
          </div>
        </div>
        `;
      }
    });

    if(count === this.Account.contacts.length) {
      selectHtml = '<option value="">-- All Contacts Selected --</option>';
    } else if(count === 3) {
      selectHtml = '<option value="">-- Maximum Selected --</option>';
    } else if(this.Account.contacts.length > 0) {
      selectHtml = '<option value="">-- Select Contact --</option>' + selectHtml;
    } else {
      selectHtml = '<option value="">-- No Contacts Found --</option>';
    }

    this.emailReportContactsSelect.innerHTML = selectHtml;
    this.emailReportContacts.innerHTML = selectedHtml;
    this.emailReportContactCount.innerHTML = `(${count} / 3)`;

  }

  render() {

    const columns = supportedCsvDatapoints;

    let html = `
    <p>Get an archive of your sensor readings in your email every day, week or month</p>

    <div class="setting">

      <div class="setting__input">

        <div class="setting__switch">
          <div class="setting__switch__value">
            <div class="switch medium">
              <input class="switch-input" type="checkbox" id="send_reports" name="send_reports" value="1">
              <label class="switch-paddle" for="send_reports">
                <span class="switch-active">Yes</span>
                <span class="switch-inactive">No</span>
              </label>
            </div>
          </div>
          <div class="setting__switch__label">Enable Email Reports</div>
        </div>

      </div>

    </div>

    <div class="setting setting--conditional" data-for="send_reports">

      <div class="divider"></div>

      <h4 class="heading heading--smaller">Contacts</h4>
      <p>Select up to three contacts to receive email reports <span class="account-email-reports__contact-count">(0 / 3)</span></p>

      <div class="account-email-reports__contacts-select">
        <select data-for="account-email-reports-contacts">
          <option value="">Loading...</option>
        </select>
      </div>

      <div class="account-email-reports__contacts"></div>

      <div class="account-email-reports__contacts__add-contact">
        <button type="button" class="button button--small button--gray add-contact-button"><i class="fa fa-solid fa-plus"></i> New Contact</button>
      </div>

      <div class="divider"></div>

      <h4 class="heading heading--smaller">Sensors</h4>

      <div class="setting">

        <div class="setting__input">

          <div class="setting__switch">
            <div class="setting__switch__value">
              <div class="switch medium">
                <input class="switch-input" type="checkbox" id="reports_specific_sensors" name="reports_specific_sensors" value="1">
                <label class="switch-paddle" for="reports_specific_sensors">
                  <span class="switch-active">Yes</span>
                  <span class="switch-inactive">No</span>
                </label>
              </div>
            </div>
            <div class="setting__switch__label">Only create reports for specific sensors</div>
          </div>

        </div>

      </div>

      <div class="setting setting--conditional" data-for="reports_specific_sensors">

        <div class="account-email-reports__sensors-select">
          <select data-for="account-email-reports-sensors">
            <option value="">Loading...</option>
          </select>
        </div>

        <div class="account-email-reports__sensors"></div>

      </div>

      <div class="divider"></div>

      <h4 class="heading heading--smaller">Data points</h4>
      <p>Select which data points (if supported by your sensor) to include with your reports</p>

      ${columns.map(column => {
          return `
          <label class="account-csv-settings__include">
            <div class="account-csv-settings__include__checkbox">
              <input type="checkbox" value="${column.id}" name="reports_datapoints[]"
               ${window.currentUser && window.currentUser.reports_datapoints && window.currentUser.reports_datapoints.includes(column.id) ? 'checked' : ''}
               />
            </div>
            <div class="account-csv-settings__include__label">${column.name}</div>
          </label>
          `
        }).join('')}

        `;

        html += `
        <div class="divider"></div>

        <h4 class="heading heading--smaller">Schedule Reports</h4>
        `;

          const reportTypes = [
            {key: "daily_reports", label: "Daily"},
            {key: "weekly_reports", label: "Weekly"},
            {key: "monthly_reports", label: "Monthly"},
          ];

          reportTypes.forEach(type => {
            html += `
            <div class="setting">

              <div class="setting__input">

                <div class="setting__switch">
                  <div class="setting__switch__value">
                    <div class="switch medium">
                      <input class="switch-input" type="checkbox" id="${type.key}" name="${type.key}" value="1">
                      <label class="switch-paddle" for="${type.key}">
                        <span class="switch-active">Yes</span>
                        <span class="switch-inactive">No</span>
                      </label>
                    </div>
                  </div>
                  <div class="setting__switch__label">Send ${type.label}</div>
                </div>

              </div>

            </div>
            `;

            html += `<div class="setting setting--conditional" data-for="${type.key}">`;

            switch(type.key) {
              case('daily_reports'):
                html += '<p class="setting__description">You will receive a daily report at the end of each day</p>';
                break;

              case('weekly_reports'):
                html += `                
                <div class="account-report-select">
                  <div class="account-report-select__label">
                    Weekly report day
                  </div>
                  <div class="account-report-select__value">
                    <select name="weekly_report_day">
                      <option value="1">Sunday</option>
                      <option value="2">Monday</option>
                      <option value="3">Tuesday</option>
                      <option value="4">Wednesday</option>
                      <option value="5">Thursday</option>
                      <option value="6">Friday</option>
                      <option value="7">Saturday</option>
                    </select>
                    <p class="setting__description">You will get a weekly report on this day</p>
                  </div>
                </div>
                `;
                break;

              case('monthly_reports'):
                html += `
                <p class="setting__description">
                  You will receive a monthly report at the end of each month
                </p>
                `;
                break;
            }

            html += `
            <div class="account-reports-download-list" data-for="${type.key}"></div>
            `;

            html += '</div>';

          });

      html += `
      </div>
      `;

      this.container.innerHTML = html;

  }

}

export default AccountEmailReports;
